import React, { useState } from 'react';
import { Button, InputNumber, Modal } from 'antd';

import { TeamFeedBalance } from '@cbinsights/datafeedcreditservice/datafeedcreditservice';
import { useAddFeedCredits } from 'client/modules/data-feed-credit/hooks/queries/data-feed-credit';

export const AddFeedCreditsButton = ({
  className,
  team,
  teamBalance,
}: {
  className?: string;
  team: { idTeam: number };
  teamBalance: TeamFeedBalance;
}): React.ReactElement => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [amount, setAmount] = useState(0);
  const { error, isLoading, mutateAsync, reset } = useAddFeedCredits();

  const closeModal = () => {
    setIsModalOpen(false);
    setAmount(0);
    reset();
  };

  const submitAddCredits = () => {
    if (amount > 0)
      mutateAsync({ idTeam: team.idTeam, amount }).then(closeModal);
  };

  return (
    <>
      <Button
        className={className}
        onClick={() => setIsModalOpen(true)}
        type="primary"
      >
        Add Credits
      </Button>
      {isModalOpen && (
        <Modal
          title="Add Credits"
          okButtonProps={{
            disabled: isLoading || amount === 0,
            loading: isLoading,
          }}
          onOk={submitAddCredits}
          onCancel={() => {
            if (!isLoading) closeModal();
          }}
          visible
        >
          <InputNumber
            addonBefore="Amount"
            autoFocus
            min={0}
            max={100000000}
            onChange={(value) => setAmount(Number(value) || 0)}
            onPressEnter={submitAddCredits}
            step={1000}
            value={amount}
          />
          <p className="mt-4">
            <span className="font-medium">Current Balance: </span>
            {teamBalance.current_balance}
          </p>
          {amount > 0 && (
            <p className="text-green-600">
              <span className="font-medium">New Balance: </span>
              {Number(teamBalance.current_balance) + amount}
            </p>
          )}
          {error && (
            <p className="text-red-600 text-sm mt-2">
              Something went wrong, please try again.
            </p>
          )}
        </Modal>
      )}
    </>
  );
};

export default AddFeedCreditsButton;
